import { createFileRoute, Link } from "@tanstack/react-router";
import { FormattedMessage } from "react-intl";
import { getCourse } from "@/lib/data/courses";
import { useCourseProgressStore } from "@/lib/stores/courseProgressStore";
import { CoursePlayer } from "@/components/trainer/CoursePlayer";

export const Route = createFileRoute("/trainer/courses/$courseSlug/player")({
  component: CoursePlayerRoute,
  validateSearch: (search: Record<string, unknown>): { slide?: string } =>
    typeof search.slide === "string" && search.slide
      ? { slide: search.slide }
      : {},
});

function CoursePlayerRoute() {
  const { courseSlug } = Route.useParams();
  const { slide } = Route.useSearch();
  const course = getCourse(courseSlug);
  const hasHydrated = useCourseProgressStore((s) => s.hasHydrated);

  if (!course) {
    return (
      <main className="px-4 py-10 text-center">
        <p className="text-body text-dark-gray">
          <FormattedMessage id="trainer.course.notFound" />
        </p>
        <Link
          to="/trainer/courses"
          className="mt-3 inline-block text-small font-medium text-primary"
        >
          <FormattedMessage id="trainer.course.backToCourses" />
        </Link>
      </main>
    );
  }

  if (!hasHydrated) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-secondary border-t-primary" />
        <span className="sr-only">
          <FormattedMessage id="common.loading" />
        </span>
      </div>
    );
  }

  return <CoursePlayer course={course} startSlideId={slide} />;
}
